import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { BRAND } from '@/lib/config/brand'
import { testIds } from '@/lib/test-ids'
/**
 * Minimal surface after Basecamp OAuth completes on the API.
 * When opened in a popup, notifies the opener and attempts window.close().
 * Same-tab flow shows a link back into the app.
 */
export function BasecampOAuthDonePage() {
  const [closeAttempted, setCloseAttempted] = useState(false)

  useEffect(() => {
    const origin = window.location.origin
    if (window.opener && !window.opener.closed) {
      try {
        window.opener.postMessage({ type: 'flownotes-basecamp-connected' }, origin)
      } catch {
        // Cross-origin or closed; opener can still poll auth
      }
    }
    const timer = window.setTimeout(() => {
      setCloseAttempted(true)
      try {
        window.close()
      } catch {
        // ignore
      }
    }, 400)
    return () => window.clearTimeout(timer)
  }, [])

  const hasOpener = typeof window !== 'undefined' && !!window.opener

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-background p-6 text-center"
      data-testid={testIds.oauth.basecampDone}
    >
      <h1 className="text-xl font-semibold text-foreground mb-2">Basecamp connected</h1>
      <p className="text-sm text-muted-foreground max-w-md mb-6">
        {hasOpener
          ? `You can close this window and return to ${BRAND.displayName}. If it stays open, use Close window below.`
          : `Return to ${BRAND.displayName} to continue.`}
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        {hasOpener && (
          <Button type="button" variant="secondary" onClick={() => window.close()}>
            Close window
          </Button>
        )}
        <Button asChild variant="default">
          <a href="/">Open {BRAND.displayName}</a>
        </Button>
      </div>
      {closeAttempted && hasOpener && (
        <p className="text-xs text-muted-foreground mt-8 max-w-sm">
          If the window did not close automatically, your browser may require you to close it manually.
        </p>
      )}
    </div>
  )
}
